import { render } from "./preview.vue?vue&type=template&id=c63b9b0a&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"

import "./preview.vue?vue&type=style&index=0&id=c63b9b0a&lang=scss&scoped=true"

import exportComponent from "D:\\新建文件夹\\workPage\\OA H5\\stgd.oa.mobile.h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c63b9b0a"]])

export default __exports__